import { useRef, useState } from "react";
import LayeredDashboardHeader from "../../LayeredDashboardHeader";
import BillingMain from "./BillingMain";
import useCustomNavigate from "../../../components/operational/goBack";


const Billing = ({ tab }) => {

    const formButtonRef = useRef()
    const goBack = useCustomNavigate(tab)

    const onSave = () => {
        formButtonRef.current?.click()
    }
    const afterFormSubmit = (response) => {

        if (response?.error) return
        goBack()
    }
    return (
        <>
            <LayeredDashboardHeader tab={tab} onSave={onSave}></LayeredDashboardHeader>
            <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
                <div>
                    <BillingMain callback={afterFormSubmit} formButtonRef={formButtonRef}></BillingMain>
                </div>
            </div>
        </>


    );
};

export default Billing;
